module.exports = __webpack_public_path__ + "static/media/goldenpapaya.bb54a06f.webp";